<!--
 * @Author       : soul-land3d
 * @Date         : 2022-04-26 15:29:48
 * @LastEditTime: 2023-10-07 10:57:09
 * @FilePath: /global-coins-moblie/src/pages/Detail/components/Tips/soulLand3d.vue
 * @developer    : yangfan36
-->
<template>
  <div class="soul-land3d-tips">
    <van-popover
      v-model="showPopover"
      trigger="click"
      @select="onSelect"
      get-container=".soul-land3d-tips"
    >
      <!-- 产品 确定写死# 牛冬 -->
      <div class="content">
        {{ languageMsg }}
      </div>
      <template #reference>
        <!-- <div class="tips-icon-box" v-if="isMobile"> -->
        <div class="tips-icon-box">
          <img
            :class="['tips-icon', displayModeClassName]"
            alt="tips-icon"
            :src="require(`@/assets/images/detail/common/tips.png`)"
            @click="showTips"
          />
        </div>
        <!-- <MBIcon color="rgba(255, 255, 255, 0.3)" name="icon-question" v-else /> -->
      </template>
    </van-popover>
  </div>
</template>

<script>
  // import MBIcon from '@/components/MBIcon'
  import { mapState, mapGetters } from 'vuex'

  // 目前只在当前组件使用、不依赖其他逻辑 暂放与此
  const LANGUAGE = {
    th: `รายการที่จำกัดการซื้อสามารถซื้อได้หลังจากลงชื่อเข้าใช้เกมแล้วเท่านั้น โปรดลงชื่อเข้าใช้เกมและรีเฟรชหน้านี้ เวลาเข้าสู่ระบบที่ถูกต้อง: 05:00 น. ของวันปัจจุบัน ถึง 04:59 น. ของวันถัดไป`,
    zh: `限購道具需要在登入遊戲後才能購買，請登入遊戲後再刷新本頁面。登錄有效時間：當日05:00-次日04:59。`,
  }
  export default {
    props: {},
    components: {
      // MBIcon,
    },
    data() {
      return {
        showPopover: false,
      }
    },
    watch: {},
    computed: {
      ...mapState(['gameName', 'region', 'isMobile']),
      ...mapGetters(['displayModeClassName']),

      languageMsg() {
        return LANGUAGE[this.region] || LANGUAGE['zh']
      },
    },
    methods: {
      showTips() {},
      onSelect() {},
    },
  }
</script>

<style lang="scss" scoped>
  .soul-land3d-tips {
    display: flex;
    align-items: center;
    .tips-icon {
      height: 44px;
      width: 44px;
      margin-left: 16px;
      font-size: 0;
    }

    .content {
      width: 540px;
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 800;
      font-size: 39px;
      line-height: 53px;
      color: #ffffff;
      padding: 30px;
      background: #f96000;
    }
    .tips-icon-box {
      display: flex;
      align-items: center;
    }
  }
  @media screen and (min-device-width: 1080px) {
    .soul-land3d-tips {
      display: flex;
      align-items: center;
      .content {
        width: 250px;
        font-family: 'Manrope';
        font-style: normal;
        font-weight: 800;
        font-size: 14px;
        line-height: 30px;
        color: #ffffff;
        padding: 15px;
        background: #f96000;
      }

      .tips-icon {
        height: 20px;
        width: 20px;
        margin-left: 5px;
        font-size: 0;
        cursor: pointer;
      }

      // ::v-deep {
      //   .mb-icon-question {
      //     margin-left: 8px;
      //   }
      // }
    }
  }
</style>
<style lang="scss">
  .soul-land3d-tips {
    .van-popover--light .van-popover__arrow {
      color: #f96000;
    }
  }
</style>
